import { BaseFormField, FieldWrapper } from './Base'
import clientStyles from '../ClientStyles'

class TextInput extends BaseFormField {
    render() {
        const { field, value, placeholder, required } = this.state

        return (
            <FieldWrapper field={field}>
                <input
                    // name={"field-" + field.getUid()}
                    type="text"
                    className={'form-control ' + clientStyles.getTextinputClass()}
                    placeholder={placeholder}
                    onChange={this.handleChange}
                    defaultValue={value}
                    required={required}
                />
            </FieldWrapper>
        )
    }
}

export default TextInput
